import { LINE_HEIGHT_DEFAULT, LINE_HEIGHT_TYPES } from './lineHeightConfig';

/**
 * Global attribute config for LineHeightExtension.
 * Adds line-height to paragraph, heading, bulletList and orderedList nodes.
 * CSS inheritance handles list items automatically when applied to the container.
 */
export const lineHeightAttribute = [
    {
        types: LINE_HEIGHT_TYPES,
        attributes: {
            lineHeight: {
                default: LINE_HEIGHT_DEFAULT,
                parseHTML: (el) => parseFloat(el.style.lineHeight) || LINE_HEIGHT_DEFAULT,
                renderHTML: (attrs) =>
                    attrs.lineHeight && attrs.lineHeight !== LINE_HEIGHT_DEFAULT
                        ? { style: `line-height: ${attrs.lineHeight}` }
                        : {},
            },
        },
    },
];
